import React from 'react';
import { Dialog, Grid } from '@material-ui/core';
import { SessionScoreType } from 'src/modules/shared/slices/study-card/api/studyCard';
import { DialogDivider, ScoreDialogContainer, ScoreDialogTitle } from '../atoms/styles';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import {
  SpriteIconsLight,
  SpriteIconsRegular,
  SpriteIconsSolid,
} from 'src/config/api/models/FontAwesome';
import { useTranslation } from 'react-i18next';

type ScoreDialogProps = {
  isOpen: boolean;
  score: SessionScoreType;
  onClose: () => void;
};

export const ScoreDialog: React.FC<ScoreDialogProps> = ({ isOpen, score, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog PaperProps={{ style: { borderRadius: '16px' } }} open={isOpen} onClose={onClose}>
      <ScoreDialogTitle>
        <span>
          <FontAwesomeSpriteIcon
            icon={SpriteIconsRegular.PROGRESS_BAR}
            color="secondary"
            iconSize="1x"
          />
          Progressie
        </span>
      </ScoreDialogTitle>
      <ScoreDialogContainer>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <span style={{ fontWeight: 'bolder' }}>Deze sessie</span>
          </Grid>
          <Grid item xs={12}>
            <div>
              <span>
                <FontAwesomeSpriteIcon icon={SpriteIconsLight.TIMER} iconSize="sm" />
                {score?.practiceTime}
              </span>
            </div>
          </Grid>

          {score?.cards?.map((typeOfCard) => (
            <Grid key={typeOfCard.type} item container spacing={2} xs={12}>
              <Grid item xs={12}>
                <span style={{ fontWeight: 'bolder' }}>
                  {typeOfCard.quantity} {t(typeOfCard.type)}
                </span>
              </Grid>
              <Grid item xs={6}>
                <span>
                  <FontAwesomeSpriteIcon icon={SpriteIconsLight.EYE} iconSize="sm" />
                  {typeOfCard.amountOfViews} bekeken
                </span>
              </Grid>
              <Grid item xs={6}>
                <span>
                  <FontAwesomeSpriteIcon icon={SpriteIconsSolid.CHECK} iconSize="sm" />
                  {typeOfCard.amountOfKnows} gekend
                </span>
              </Grid>
            </Grid>
          ))}
        </Grid>
        <DialogDivider />
        <Grid item xs={12}>
          <span style={{ fontWeight: 'bolder' }}>Voor dit traject</span>
        </Grid>
        <Grid item container xs={12} spacing={0}>
          <Grid item xs={5}>
            <div>
              <span>
                <FontAwesomeSpriteIcon icon={SpriteIconsLight.BRAIN} iconSize="sm" />
                {score?.amountOfSessions} trainingsessies
              </span>
            </div>
          </Grid>
          <Grid item xs={5}>
            <div>
              <span>
                <FontAwesomeSpriteIcon icon={SpriteIconsLight.TIMER} iconSize="sm" />
                {score?.totalPracticeTime}
              </span>
            </div>
          </Grid>
          <Grid item xs={5}>
            <div>
              <span>
                <FontAwesomeSpriteIcon icon={SpriteIconsLight.EYE} iconSize="sm" />
                {score?.totalAmountOfViews} bekeken
              </span>
            </div>
          </Grid>
          <Grid item xs={5}>
            <div>
              <span>
                <FontAwesomeSpriteIcon icon={SpriteIconsSolid.CHECK} iconSize="sm" />
                {score?.amountOfIsKnown} van {score?.amountOfCards} gekend
              </span>
            </div>
          </Grid>
        </Grid>
      </ScoreDialogContainer>
    </Dialog>
  );
};
